export const LOGIN_AUTH_PATH = 'log-in'

export const SIGNUP_AUTH_PATH = 'sign-up'

export const TWO_HOURS_IN_SECONDS = 7200
